module.exports = __webpack_public_path__ + "img/TORRES.4dcc09c5.png";